<template>
    
    <PageTitle title="Add Namecard" :breadcrumb="[ { name: 'Namecard', link: '/namecard' }, { name: 'Add Namecard' } ]"></PageTitle>

    <div class="page-body">
        <div class="container-xl">
            <div class="row row-cards">
                <div class="col-12">
                    
                    <div class="card mb-3">
                        <div class="card-body mb-4">
                            <h4 class="card-title">Select Template</h4>
                            <div class="card-subtitle">Click the image to select template</div>
                            <div class="row namecard-template text-center">
                                <div class="col-lg-2" v-for="(template, index) in templates" :key="index">
                                    <img ondragstart="return false;" :src="template.front_template" @click="setTemplate(template)" :data-id="template.id" 
                                    :class="[ template.id == form.template_id ? 'active': '' ]"/>
                                    <h2 class="text-muted">{{ template.name }}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card-body mb-4" v-if="form.template_id">
                            <h4 class="card-title">User Info</h4>
                            <div class="row">
                                <div class="col-lg-5 mb-3">

                                    <div class="mb-3">
                                        <div class="form-label">Initial Name</div>
                                        <label class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" @change="nameToggle" :checked="nameToggleLabel">
                                            <span class="form-check-label">{{nameToggleLabel ? "Show" : "Hide"}}</span>
                                        </label>
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Name (Chinese)</div>
                                        <input type="text" class="form-control" v-model="namecn">
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Rank Name (Chinese)</div>
                                        <label class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" @change="rankToggle">
                                            <span class="form-check-label">{{ranknamecnToggle ? "Show" : "Hide"}}</span>
                                        </label>
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Photo</div>
                                        <label class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" @change="photoToggle" :checked="photoToggleLabel">
                                            <span class="form-check-label">{{photoToggleLabel ? "Show" : "Hide"}}</span>
                                        </label>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Email</label>
                                        <input type="email" class="form-control" v-model="email" :class="{ 'is-invalid': error.email}">
                                        <div class="invalid-feedback">{{ error.email }}</div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Cert-In-CES</label>
                                        <input type="text" class="form-control mb-1" v-model="info.certInCes" maxlength="30">
                                        <input type="text" class="form-control" v-model="info.certInCes2" maxlength="30">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Social Media Accounts</label>
                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Website</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.web" maxlength="30">
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Facebook</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.fb" maxlength="30">
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Instagram</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.ig" maxlength="30">
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Tiktok</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.tiktok" maxlength="30">
                                            </div>
                                        </div>

                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Order Quantity</label>
                                        <VueMultiselect selectLabel="" v-model="package_id" :options="packages" :multiple="false" group-values="packages" group-label="category" :group-select="false" placeholder="Type to search" track-by="name" label="name" :class="{ 'is-invalid': error.package_id}">
                                            <span>Oops! No elements found. Consider changing the search query.</span>
                                        </VueMultiselect>
                                        <div class="invalid-feedback">{{ error.package_id }}</div>
                                    </div>

                                    <div class="mt-4">
                                        <div class="d-flex">
                                            <router-link :to="{ name: 'Namecard' }" class="btn btn-link">Cancel</router-link>
                                            <button type="submit" class="btn btn-success ms-auto" @click="submit" v-if="package_id">
                                                <span>Proceed to Payment</span> 
                                                <i class="ti ti-chevron-right"></i>
                                            </button>
                                            <button type="submit" class="btn btn-success ms-auto" disabled="disabled" v-else>
                                                <span>Proceed to Payment</span> 
                                                <i class="ti ti-chevron-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-7 overflow-auto">
                                    <CustomTa1 v-if="form.template.name == 'F1'"/>
                                    <CustomTa2 v-if="form.template.name == 'F2'"/>
                                    <CustomTa3 v-if="form.template.name == 'F3'"/>
                                    <CustomTa4 v-if="form.template.name == 'F4'"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import PageTitle from '../../components/PageTitle.vue';
import CustomTa1 from './components/CustomTa1.vue';
import CustomTa2 from './components/CustomTa2.vue';
import CustomTa3 from './components/CustomTa3.vue';
import CustomTa4 from './components/CustomTa4.vue';
import { ref, onMounted, inject, getCurrentInstance } from 'vue';
import { useRouter } from "vue-router";
import { store } from '../../store.js';
import axios from 'axios';
import VueMultiselect from 'vue-multiselect';

export default {
    components: {
        PageTitle,
        CustomTa1,
        CustomTa2,
        CustomTa3,
        CustomTa4,
        VueMultiselect
    },
    setup() {
        const app = getCurrentInstance();
        const router = useRouter();
        const swal = inject('$swal');
        const form = ref([]);
        const social = ref({
            web: '',
            fb: '',
            ig: '',
            tiktok: ''
        });
        const templates = ref([]);
        const package_id = ref(false);
        const info = ref([]);
        const email = ref('');
        const name = ref('');
        const namecn = ref('');
        const namenoInitial = ref('');
        const error = ref([]);
        const packages = ref([]);
        const ranknamecnToggle = ref(false);
        const nameToggleLabel = ref(false);
        const photo = ref('');
        const photoToggleLabel = ref(true);

        async function getTemplates() {
            store.loading = true;
            await axios
            .get(process.env.VUE_APP_ENDPOINT+'/namecard/templates')
            .then(function (res) {
                store.loading = false;
                templates.value = res.data.namecards;
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    swal({
                        icon: 'error',
                        text: app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        }

        async function getInfo() {
            store.loading = true;
            await axios
            .get(process.env.VUE_APP_ENDPOINT+'/namecard/user')
            .then(function (res) {
                store.loading = false;
                info.value = res.data.user;
                email.value = res.data.user.email;
                name.value = res.data.user.name;
                namenoInitial.value = res.data.user.name_noinitial;
                photo.value = res.data.user.photo;

                let namecard = JSON.parse(localStorage.getItem('namecard'));
                if (namecard && namecard.photo) {
                    info.value.photo = namecard.photo;
                    info.value.photo_name = namecard.photo_name;
                }
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    swal({
                        icon: 'error',
                        text: app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        }

        async function getPackages() {
            store.loading = true;
            await axios
            .get(process.env.VUE_APP_ENDPOINT+'/namecard/packages')
            .then(function (res) {
                store.loading = false;
                packages.value = res.data.packages;
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    swal({
                        icon: 'error',
                        text: app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        }

        onMounted(() => {
            getInfo();
            getTemplates();
            getPackages();
        });

        return { store, swal, router, form, templates, package_id, info, social, name, namecn, namenoInitial, email, error, packages, ranknamecnToggle, nameToggleLabel, photo, photoToggleLabel }
    },
    methods: {
        setTemplate (template) {
            this.form.template_id = template.id;
            this.form.template = template;
            store.namecard.template = template;
            store.namecard.user = this.info;
            store.namecard.social = this.social;
            
            //default no initial
            store.namecard.user.name = this.namenoInitial;
        },
        uploadPhoto() {
            var fileElement = document.getElementById('inputFile');
            this.info.photo = URL.createObjectURL(fileElement.files[0]);
        },
        importBtn() {
            document.getElementById('inputFile').click();
        },
        async importFile() {
            store.loading = true;
            this.showUploadBtn = false;
            let model = this;

            if(store.namecard.user.photo != '')
            {
                var formData = new FormData();
                formData.append("photo", store.namecard.user.profile_default_photo);
                await axios
                .post(process.env.VUE_APP_ENDPOINT+'/namecard/photo',formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(function (res) {
                    store.loading = false;
                    store.namecard.user.photo = res.data.path;
                    store.namecard.user.photo_name = res.data.filename;
                    model.goSubmit();
                })
                .catch(function (error) {
                    store.loading = false;
                    if (error.response && error.response.status == 401) {
                        model.router.push({ name: 'Logout' });
                    } else if (error.response && error.response.status != 500) {
                        model.swal({
                            icon: 'error',
                            text: error.response.data.message,
                            showCloseButton: true,
                            showConfirmButton: false
                        });
                    } else {
                        model.swal({
                            icon: 'error',
                            text: model.app.appContext.config.globalProperties.$error500,
                            showCloseButton: true,
                            showConfirmButton: false
                        });
                    }
                });
            } else {
                store.loading = false;
                model.goSubmit();
            }
        },
        submit () {
            this.error.form = false;
            this.clear();

            if (!this.email) {
                this.error.form = true;
                this.error.email = 'Email is required';
            }

            if (!this.package_id) {
                this.error.form = true;
                this.error.package_id = 'Package is required';
            }

            if (!this.error.form) {
                this.importFile();
            }
        },
        async goSubmit() {
            store.loading = true;
            let model = this;
            let cert = '';
            if (this.info.certInCes && this.info.certInCes2) {
                cert = this.info.certInCes + "\n" + this.info.certInCes2;
            } else if (this.info.certInCes && !this.info.certInCes2) {
                cert = this.info.certInCes;
            } else if (!this.info.certInCes && this.info.certInCes2) {
                cert = this.info.certInCes2;
            }


            await axios
            .post(process.env.VUE_APP_ENDPOINT+'/namecard/orders',{
                namecard_id: this.form.template_id,
                package_id: this.package_id.id,
                photo:  store.namecard.user.photo_name,
                email: this.email,
                name: store.namecard.user.name,
                name_cn: this.namecn,
                rank: this.info.position,
                rank_cn: store.namecard.user.ranknamecn,
                cea_cert: cert,
                social: {
                    web: store.namecard.social.web,
                    fb: store.namecard.social.fb,
                    ig: store.namecard.social.ig,
                    tiktok: store.namecard.social.tiktok,
                },
                hide_initial: this.nameToggleLabel ? 'N' : 'Y',
                cea_regno: store.namecard.user.cea_regno
            })
            .then(function (res) {
                store.loading = false;
                localStorage.removeItem('namecard');
                model.router.push('/namecard/payment/'+res.data.order);
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    model.router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    model.swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    model.swal({
                        icon: 'error',
                        text: model.app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        },
        rankToggle() {
            this.ranknamecnToggle = !this.ranknamecnToggle;
            if(this.ranknamecnToggle)
            {
                store.namecard.user.ranknamecn = store.namecard.user.position_cn;
            } else {
                store.namecard.user.ranknamecn = '';
            }
        },
        nameToggle() {
            let model = this;
            model.nameToggleLabel = !model.nameToggleLabel;
            if(model.nameToggleLabel)
            {
                store.namecard.user.name = model.name;
            } else {
                store.namecard.user.name = model.namenoInitial;
            }
        },
        photoToggle() {
            let model = this;
            model.photoToggleLabel = !model.photoToggleLabel;
            if(model.photoToggleLabel)
            {
                store.namecard.user.photo = model.photo;
            } else {
                store.namecard.user.photo_name = '';
                store.namecard.user.photo = '';
            }
        },
        clear() {
            this.error = [];
        }
    },
    watch: {
        email () {
            if (!this.email) {
                this.error.form = true;
                this.error.email = 'Email required';
            } else {
                if (store.namecard.user) {
                    store.namecard.user.email = this.email;
                }
                this.error.form = false;
                this.error.email = '';
            }
        },
        package_id() {
            let model = this;
            this.packages.forEach(function(row) {
                if (row.id == model.package_id.id) {
                    store.pay.points = model.info.total_points;
                    store.pay.points_text = model.info.total_points_text;
                    store.pay.amount = row.amount;
                }
            });
        },
        namecn() {
            if(store.namecard.user)
            {
                store.namecard.user.namecn = this.namecn;
            }
        }
    }
}
</script>
<style src="@/assets/vue-multiselect.min.css"></style>
<style>
    .namecard-template img {
        width: 250px;
        border: 3px solid #EAECEE;
        cursor: pointer;
    }

    .namecard-template img:hover {
        border: 3px solid #981D10
    }

    .namecard-template img.active {
        border: 3px solid #981D10
    }

    .multiselect__option--group {
        font-weight: bold;
    }

    .multiselect__option--highlight {
        background:#FCEBEC;
        color:#D63F3E;
    }
</style>